import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { SignInEmailRequest } from "../../../shared/interfaces/components/signin.interface";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";

export const emailGetSignIn = (payload: SignInEmailRequest) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/login/${payload.email}`;
  // it was necessary remove the query parameters because krakend has trouble reading character '@'
  // when an email is passed as a query parameter
  return apiClient
    .get(URL)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
